import React, { Component } from 'react'
import styled from 'styled-components'
import media from '../../styles/media'

const OvalWrapper = styled.div`
  width: 220px;
  height: 220px;
  margin: 20px auto 0;
  ${media.md`
    width: 320px;
    height: 320px;
    margin: 0 auto;
  `};
`

function Oval(props) {
  const { img } = props
  return (
    <OvalWrapper>
      <img src={img} alt="PPM" className="img-fluid" />
    </OvalWrapper>
  )
}

export default Oval



// WEBPACK FOOTER //
// ./src/components/oval/oval.js